// extracted by mini-css-extract-plugin
export default {"App":"App_App__a1xjl","hobby":"App_hobby__bgE+g"};